import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

import SearchComponent from "../../components/ui/Search";
import HomeSkeleton from "./component/HomeSkeleton";

import useUpdateHome from "./hooks";
import { useSelector } from "react-redux";
import { IRootState } from "../..";
import Category from "./categories/Category";
import Estalishments from "./establishments/Estalishments";
import SpecialOffer from "./specialoffer/SpecialOffer";
import Banners from "./banners/Banners";
import TopRestaurant from "./toprestaurants/TopRestaurant";
import TopSupermarket from "./topsupermarket/TopSupermarket";
import TopStore from "./topstore/TopStore";
import MostReviewed from "./mostreviewed/MostReviewed";

import "./home.css";
import { useNavigate } from "react-router-dom";
import notify from "../../utils/notify";

const HomePage = () => {
  const navigate = useNavigate();
  const home = useSelector((state: IRootState) => state.home.value);
  const cord = useSelector((state: IRootState) => state.profile.value);
  const user = useSelector((state: IRootState) => state.user.value);

  useEffect(()=>{
    if(user.email_verified_at === null){
      navigate("/resend-otp")
    }
  }, [navigate, user])
  const { updateHome } = useUpdateHome();

  useEffect(() => {
    updateHome({
      lat: cord.cord.lat,
      lng: cord.cord.lng,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cord.cord]);

  const [searchInput, setSearchInput] = useState("");
  const onSearch = (e: any) => {
    setSearchInput(e.target.value);
  };
  const coordinates = localStorage.getItem("cord");
  return (
    <div>
      <div className="">
        <div className="md:bg-homeBg bg-homeBgMob bg-cover bg-no-repeat">
          <div className="container mx-auto pt-36 pb-16 md:pt-32">
            <div className="flex flex-col justify-center items-center gap-5 text-white">
              <div className="head font-bold text-2xl md:text-4xl leading-7 text-center">
                Get item Asap from <br className="" /> favourite store
              </div>
              <div className="text-sm md:text-base mb-4">
                Find your happiness & delicious foods
              </div>
              <SearchComponent
                searchInput={searchInput}
                setSearchInput={onSearch}
                placeholder="Search for foods and restaurants"
                setSearch={() => {
                  if(coordinates === null){
                    notify("error", "Please Select your Address to search for items")
                  }else{
                    if (searchInput.trim() !== "") {
                      navigate(`/search/items?q=${searchInput}`);
                    } else {
                      notify("error","Please enter a search term.");
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="bg-[#3E1200] flex-nowrap text-sm text-white py-2">
          <Marquee speed={20}>
            <div className="text-[10px]">
              SIGN UP TO EARN REWARDS & STAND A CHANCE TO EARN 50% DISCOUNT ON
              YOUR FIRST ORDER
            </div>
          </Marquee>
        </div>
        <Estalishments />
        {home.homeLoading ? (
          <HomeSkeleton />
        ) : (
          <div className="">
            <Category />
            <div className="bg-[#F9F9F9] py-4">
              {home.home.itemCampaigns && <SpecialOffer />}
              {home.home.popular && <TopStore />}
            </div>
            <div className="bg-white py-3">
              {home.home.banners && <Banners />}
              {home.home.most_reviewed && <MostReviewed />}
              {home.home.popular && <TopRestaurant />}
              {home.home.popular && <TopSupermarket />}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
